module.exports = __webpack_public_path__ + "img/mosquita_error.8c8d8cca.png";